<template>
  <div>
    <el-card v-loading="isLoading">
      <el-row>
        <el-col :span="6">
          <title-header v-if="competenciaSelected"
                        :ano="competenciaSelected.ano"
                        :mes="competenciaSelected.mes"
                        :status="competenciaSelected.status">
          </title-header>
        </el-col>
        <el-col :span="18" align="right">
          <index-filter @filtroAplicado="filter"></index-filter>
        </el-col>
        <el-col align="right">
          <el-button v-for="action  in actionsEnable"
                     @click="componentSelected = action.component"
                     :type="componentSelected === action.component ? 'primary' : 'default'  "
                     :icon="action.icon"
                     :key="action.component"
                     size="mini"
                     circle>
            {{action.label}}
          </el-button>

        </el-col>
      </el-row>
      <hr/>
      <el-row>
        <el-col>
          <transition name="fade" mode="out-in">
            <keep-alive>
              <component v-if="competenciaSelected"
                         :is="componentSelected"
                         :competencia="competenciaSelected"
                         :can-change="canChange"
                         @competenciaChange="competenciaChange">
              </component>
            </keep-alive>
          </transition>
        </el-col>
      </el-row>
    </el-card>
  </div>

</template>

<script>
  import {trataErrors} from '@/domain/utils'
  import {mapState, mapActions} from 'vuex'
  import Configuracao from './CompetenciaConfig'
  import Arvore from './Arvore'
  import IndexFilter from "./IndexFilter"
  import FilterButton from "../../components/shared/FilterButton"
  import TitleHeader from "./TitleHeader";
  import Meta from './MetaCentroCusto'
  import Resposta from './Resposta'
  import Processo from './Processo'
  import Copia from './Copia'

  export default {
    name: "competencia-home",
    components: {TitleHeader, FilterButton, IndexFilter, Configuracao, Arvore, Meta, Resposta, Processo, Copia},

    data() {
      return {
        actionsAvalible: [
          {component: 'Configuracao', icon: 'el-icon-setting', label: 'Configuração', dependCanChange: false},
          {component: 'Copia', icon: 'el-icon-copy', label: 'Cópia', dependCanChange: false},
          {component: 'Arvore', icon: 'fa fa-tree', label: 'Indicadores', dependCanChange: false},
          {component: 'Meta', icon: 'icon-graph', label: 'Meta', dependCanChange: false},
          {component: 'Resposta', icon: 'el-icon-edit-outline', label: 'Resposta', dependCanChange: false},
          {component: 'Processo', icon: 'fa fa-rocket', label: 'Processo', dependCanChange: true},
        ],
        showFilter: false,
        activeName: 'metas',
        componentSelected: 'Configuracao',
        competenciaSelected: null,
        isLoading: false
      }
    },
    computed: {
      ...mapState(['competenciaOpen']),
      actionsEnable() {
        return this.actionsAvalible.filter(item => {
          if (!item.dependCanChange) {
            return true;
          }
          return this.canChange;
        });
      },
      canChange() {
        if (!this.competenciaOpen || !this.competenciaSelected) {
          return false;
        }
        return this.competenciaSelected.id === this.competenciaOpen.id;
      }
    },
    methods: {
      ...mapActions('Competencia', ['setCompetencia', 'setCentroCusto']),
      async filter(event) {
        try {
          this.isLoading = true
          this.showFilter = false
          const url = `${process.env.API_PATH}/competencia/ano/${event.ano}/mes/${event.mes}`
          const {data} = await axios.get(url)
          this.competenciaSelected = {...data}
          if (!this.canChange && this.componentSelected === 'Processo') {
            this.componentSelected = 'Configuracao';
          }

        } catch (e) {
          trataErrors(e)
        } finally {
          this.isLoading = false
        }
      },
      competenciaChange() {
        this.filter({ano: this.competenciaSelected.ano, mes: this.competenciaSelected.mes})
      }
    },
    async created() {
      if (!this.competenciaOpen.id) {
        this.showFilter = true
        return
      }
      this.filter({ano: this.competenciaOpen.ano, mes: this.competenciaOpen.mes})
    }
  }
</script>

<style scoped>
  .subtitle {
    font-weight: bold;
    font-size: 1.2em;
  }
</style>



// WEBPACK FOOTER //
// src/features/Competencia/index.vue